import {
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  ChevronUp,
} from "lucide-react"; // Combined imports
import { useState, useRef } from "react";
import { FaRuler, FaMapMarkerAlt, FaStar, FaTimes } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom"; // Ensure you're using React Router
import { MdOutlineNavigateNext } from "react-icons/md";
import React from "react";
import { useEffect } from "react";
import { GiShoppingBag } from "react-icons/gi";
import { addToCart, getCartCount } from "../../utils/cartUtils";
import { addToWishlist, removeFromWishlist, getWishlistProducts } from "../../utils/wishlistUtils";
import { toast } from "react-toastify";
import { FaHeart, FaFire } from "react-icons/fa"; // Solid heart
import { FiHeart } from "react-icons/fi"; // Outline heart
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { X } from "lucide-react";
import axios from "axios";
import { IoEyeSharp } from "react-icons/io5";
import { AiOutlineThunderbolt } from "react-icons/ai";

import { FaPlus, FaMinus } from "react-icons/fa";
import { LiaTimesSolid } from "react-icons/lia";
import { TfiRulerAlt } from "react-icons/tfi";
// Swiper Imports (Mobile Slider)
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";

import { Pagination } from "swiper/modules";
import { Helmet } from "react-helmet-async";

const ProductDetail2 = ({ data }) => {
  const navigate = useNavigate();
  const productsDetails = data["get_products_details"][0];
  const productImages = data["get_products_details"][0]["product_images"];
  const sizePrice = data["get_products_details"][0]["get_price_lists"];
  const sizes = data["get_products_details"][0]["size"];
  const colors = data["color_products_lists"];
  const isCustomizable = data["get_products_details"][0]["Customizable"] === "Yes";
  const [visibleReviews, setVisibleReviews] = useState(5);
  const reviewsRef = useRef(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const app_type_id = sessionStorage.getItem("app_type_id");
  const [cartData, setCartData] = useState([]);

  const admin_auto_id = sessionStorage.getItem("admin_auto_id");
  const [pincode, setPincode] = useState(
    sessionStorage.getItem("userPincode") || "",
  );
  const [message, setMessage] = useState("");
  const [messageColor, setMessageColor] = useState("");
  const [loading, setLoading] = useState(false);
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
  const [wishlisted, setWishlisted] = useState(false);

  const allProducts = [1, 2, 3, 4, 5, 6, 7, 8]; // All products
  const visibleProducts = allProducts.slice(0, 3); // Show only 4 initially
  const scrollRef = useRef(null);

  const [selectedSize, setSelectedSize] = useState(null);
  const [currentPrice, setCurrentPrice] = useState(
    productsDetails.final_product_price,
  );

  const [currentOffer, setCurrentOffer] = useState(
    productsDetails.offer_percentage,
  );

  const [originalPrice, setOriginalPrice] = useState(
    productsDetails.product_price,
  );

  const [chartImage, setChartImage] = useState(null);
  const [chartImage2, setChartImage2] = useState(null);
  const [isSizeGuideModalOpen, setIsSizeGuideModalOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState("Size Chart");
  const toggleSizeGuideModal = () =>
    setIsSizeGuideModalOpen(!isSizeGuideModalOpen);
  const [reviews, setReviews] = useState([]); // State for dynamic reviews
  const [ratingSummary, setRatingSummary] = useState({
    5: 0,
    4: 0,
    3: 0,
    2: 0,
    1: 0,
  }); // State for rating summary
  const [totalReviews, setTotalReviews] = useState(0); // State for total reviews
  const [avgRating, setAvgRating] = useState(0); // State for average rating
  const [faqs, setFaqs] = useState([]);

  // Helper function to format date as "MonthName DD"
  const formatDate = (dateString) => {
    if (!dateString) return "Unknown Date";
    const date = new Date(dateString);
    if (isNaN(date)) return "Invalid Date";
    const month = date.toLocaleString("en-US", { month: "long" });
    const day = date.getDate().toString().padStart(2, "0");
    return `${month} ${day}`;
  };

  const getRandomBoughtCount = (count) => {
    const base = parseInt(count) || 0;
    const lower = Math.floor(base * 0.8); // -20%
    const upper = Math.ceil(base * 1.2); // +20%
    return Math.floor(Math.random() * (upper - lower + 1)) + lower;
  };

  const getRandomViewCount = (count) => {
    const base = parseInt(count) || 0;
    const lower = Math.floor(base * 0.8); // -20%
    const upper = Math.ceil(base * 1.2); // +20%
    return Math.floor(Math.random() * (upper - lower + 1)) + lower;
  };

  const [boughtCount, setBoughtCount] = useState(
    getRandomBoughtCount(productsDetails.bought_count),
  );
  // Update boughtCount when productsDetails.bought_count changes
  useEffect(() => {
    setBoughtCount(getRandomBoughtCount(productsDetails.bought_count));
  }, [productsDetails.bought_count]);

  const [themeColor, setThemeColor] = useState("#000000");
  const [themeIconColor, setThemeIconColor] = useState("#000000");
  const [webFont, setWebFont] = useState("");

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setThemeColor(parsedStyle.web_theme_colour);
      setThemeIconColor(parsedStyle.web_theme_icon_color);
      setWebFont(parsedStyle.web_font);
    }
  }, []);

  function lightenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) + 255 * percent;
    let g = ((num >> 8) & 0x00ff) + 255 * percent;
    let b = (num & 0x0000ff) + 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }

  function darkenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) - 255 * percent;
    let g = ((num >> 8) & 0x00ff) - 255 * percent;
    let b = (num & 0x0000ff) - 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }

  const [cartMessage, setCartMessage] = useState({ text: "", type: "" });
  const [isVibrating, setIsVibrating] = useState(false);
  const [wishlistMessage, setWishlistMessage] = useState({
    text: "",
    type: "",
  });

  useEffect(() => {
    if (cartMessage.text) {
      const timer = setTimeout(() => {
        setCartMessage({ text: "", type: "" });
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [cartMessage.text]);

  useEffect(() => {
    if (wishlistMessage.text) {
      const timer = setTimeout(() => {
        setWishlistMessage({ text: "", type: "" });
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [wishlistMessage.text]);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/Show-Ratings`,
          {
            product_auto_id: productsDetails.product_auto_id,
            admin_auto_id: admin_auto_id,
            app_type_id: app_type_id,
          },
        );

        if (response.data.status === 1) {
          const reviewData = response.data.getalldata.map((item) => ({
            rating: parseInt(item.rating), // Convert string to number
            date: formatDate(item.date),
            text: item.review,
            user: item.customer_name,
            location: null, // Not provided in API
            verified: false, // Not provided in API, default to false
          }));
          setReviews(reviewData);
          setTotalReviews(response.data.total_no_of_reviews);
          setAvgRating(response.data.avg_rating);

          // Calculate rating summary
          const summary = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
          reviewData.forEach((review) => {
            summary[review.rating] = (summary[review.rating] || 0) + 1;
          });
          setRatingSummary(summary);
        } else {
          console.error("Failed to fetch reviews:", response.data);
        }
      } catch (error) {
        console.error("Error fetching reviews:", error);
      }
    };

    fetchReviews();
  }, []);

  const fetchSizeChartSafe = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_size_chart_list`,
        { admin_auto_id, app_type_id },
      );

      if (response.data.status === "1") {
        const data = response.data.getalldata || [];

        const normalChart = data.find(
          (item) => item.chart_image && item.chart_image.trim() !== "",
        );

        const internationalChart = data.find(
          (item) =>
            item.international_size_chart &&
            item.international_size_chart.trim() !== "",
        );

        if (normalChart) {
          setChartImage(
            `https://grobizapp-n.s3.ap-south-1.amazonaws.com/SizeChart/${normalChart.chart_image}`,
          );
        }

        if (internationalChart) {
          setChartImage2(
            `https://grobizapp-n.s3.ap-south-1.amazonaws.com/SizeChart/${internationalChart.international_size_chart}`,
          );
        }
      }
    } catch (err) {
      console.error("Size chart error:", err);
    }
  };
  useEffect(() => {
    fetchSizeChartSafe();
  }, [admin_auto_id, app_type_id]);

  useEffect(() => {
    if (isSizeGuideModalOpen) {
      setSelectedTab("Size Chart");
    }
  }, [isSizeGuideModalOpen]);

  //   useEffect(() => {
  //   setWishlisted(productsDetails?.wishlisted === "Yes");
  // }, [productsDetails?.wishlisted]);


  useEffect(() => {
    const syncWishlistStatus = async () => {
      const token = sessionStorage.getItem("accessToken");
      if (!token || !productsDetails?.product_auto_id) {
        setWishlisted(false);
        return;
      }

      try {
        const wishlistArray = await getWishlistProducts();

        const isWishlisted = wishlistArray.some(
          (item) =>
            String(item.product_auto_id) ===
            String(productsDetails.product_auto_id)
        );

        setWishlisted(isWishlisted);
      } catch (err) {
        console.error("Wishlist sync failed:", err);
      }
    };

    syncWishlistStatus();
  }, [productsDetails.product_auto_id]);


  useEffect(() => {
    if (isSizeGuideModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    // Clean up when component unmounts
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isSizeGuideModalOpen]);

  const averageRating = data["get_products_details"][0].avg_rating;

  const [selectedSizeId, setSelectedSizeId] = useState(null);

  const handleSizeSelect = (size, index) => {
    setSelectedSize(size.size_name);
    setSelectedSizeId(size.size_auto_id);
    const selectedPrice = sizePrice[index];
    if (selectedPrice) {
      setCurrentPrice(selectedPrice.final_size_price);
      setOriginalPrice(selectedPrice.size_price);
      setCurrentOffer(selectedPrice.offer_percentage);
    }
  };

  const scroll = (direction) => {
    if (scrollRef.current) {
      const { scrollLeft, clientWidth } = scrollRef.current;
      const scrollAmount = clientWidth / 2;

      scrollRef.current.scrollTo({
        left:
          direction === "left"
            ? scrollLeft - scrollAmount
            : scrollLeft + scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const handleScroll = (direction) => {
    const container = document.getElementById("similar-products");
    const scrollAmount = 300;

    if (container) {
      if (direction === "left") {
        container.scrollLeft -= scrollAmount;
        setScrollPosition(container.scrollLeft - scrollAmount);
      } else {
        container.scrollLeft += scrollAmount;
        setScrollPosition(container.scrollLeft + scrollAmount);
      }
    }
  };

  const relatedProducts = data["get_similar_product_lists"];

  const [mainImage, setMainImage] = useState(productImages[1]); // Set default image

  useEffect(() => {
    const interval = setInterval(() => {
      setMainImage((prevImage) => {
        const currentIndex = productImages.indexOf(prevImage);
        const nextIndex = (currentIndex + 1) % productImages.length;
        return productImages[nextIndex];
      });
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating - fullStars >= 0.5;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    return (
      <>
        {[...Array(fullStars)].map((_, i) => (
          <span key={`full-${i}`} className="text-yellow-500">
            ★
          </span>
        ))}
        {hasHalfStar && <span className="text-yellow-500">☆</span>}
        {[...Array(emptyStars)].map((_, i) => (
          <span key={`empty-${i}`} className="text-gray-400">
            ★
          </span>
        ))}
      </>
    );
  };

  const ReviewComponent = () => {
    const [visibleReviews, setVisibleReviews] = useState(5);
  };

  // const [wishlisted, setWishlisted] = useState(
  //   productsDetails.wishlisted === "Yes" || false,
  // );

  const handleWishlistToggle = async (e) => {
    e.preventDefault();
    setIsVibrating(false);
    setWishlistMessage({ text: "", type: "" });
    try {
      if (wishlisted) {
        const res = await removeFromWishlist(productsDetails.product_auto_id);
        if (res?.status === 1) {
          setWishlisted(false);
        } else if (res?.triggerVibration) {
          setIsVibrating(true);
          setTimeout(() => setIsVibrating(false), 600);
          if (!sessionStorage.getItem("accessToken")) {
            setWishlistMessage({
              text: "Please sign in to add to wishlist",
              type: "error",
            });
          }
        }
      } else {
        const res = await addToWishlist(productsDetails.product_auto_id);
        if (res?.status === "1") {
          setWishlisted(true);
        } else if (res?.triggerVibration) {
          setIsVibrating(true);
          setTimeout(() => setIsVibrating(false), 600);
          if (!sessionStorage.getItem("accessToken")) {
            setWishlistMessage({
              text: "Please sign in to add to wishlist",
              type: "error",
            });
          }
        }
      }
    } catch (error) {
      console.error("Wishlist error:", error);
    }
  };

  const CustomPrevArrow = (props) => {
    const { onClick } = props;
    return (
      <button
        onClick={onClick}
        className="absolute left-0 z-10 p-1 -translate-y-1/2 bg-white rounded-full shadow-md top-1/2 hover:bg-gray-100"
      >
        <ChevronLeft className="w-5 h-5 text-gray-700" />
      </button>
    );
  };

  const CustomNextArrow = (props) => {
    const { onClick } = props;
    return (
      <button
        onClick={onClick}
        className="absolute right-0 z-10 p-1 -translate-y-1/2 bg-white rounded-full shadow-md top-1/2 hover:bg-gray-100"
      >
        <ChevronRight className="w-5 h-5 text-gray-700" />
      </button>
    );
  };

  const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          arrows: false,
        },
      },
    ],
  };

  const handleCheckPincode = async (pin) => {
    setLoading(true);
    setMessage("");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_pincode_list`,
        {
          admin_auto_id: admin_auto_id,
          user_auto_id: admin_auto_id,
        },
      );

      if (response.data.status === 1) {
        const pincodeList = response.data.get_pincode_list.map(
          (item) => item.pincode,
        );
        if (pincodeList.includes(pin.trim())) {
          setMessage(`Good news! We deliver to ${pin}.`);
          setMessageColor("text-green-600");
        } else {
          setMessage(`Sorry, currently we are unable to deliver at ${pin}.`);
          setMessageColor("text-red-600");
        }
      } else {
        setMessage("Failed to fetch delivery data.");
        setMessageColor("text-red-600");
      }
    } catch (error) {
      console.error("Error checking pincode:", error);
      setMessage("Something went wrong. Please try again.");
      setMessageColor("text-red-600");
    } finally {
      setLoading(false);
    }
  };

  // Updated useEffect for automatic pincode checking
  useEffect(() => {
    if (pincode && pincode.length >= 6 && pincode.length <= 8) {
      handleCheckPincode(pincode);
    } else if (pincode && (pincode.length < 6 || pincode.length > 8)) {
      sessionStorage.removeItem("userPincode");
      setPincode("");
    }
  }, []); // Run only on mount

  // Updated pincode input handler
  const handlePincodeChange = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // Allow only digits
    setPincode(value);
    if (value.length >= 6 && value.length <= 8) {
      handleCheckPincode(value);
    } else if ((value.length < 6 || value.length > 8) && message) {
      setMessage(""); // Clear message if pincode is invalid
      setMessageColor("");
    }
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setUploadedImage(file);
      const reader = new FileReader();
      reader.onload = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = () => {
    setUploadedImage(null);
    setImagePreview(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const [uploadedImage, setUploadedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const fileInputRef = useRef(null);

  // Function to format SKU to exactly 8 characters using only product_model_auto_id
  const formatSKU = (modelId) => {
    const rawSKU = modelId ? modelId.toString() : "";
    if (rawSKU.length > 8) {
      return rawSKU.slice(0, 8);
    }
    return rawSKU.padEnd(8, "0");
  };

  const [isBoughtFactual, setIsBoughtFactual] = useState(false);
  const [isProductViewsFactual, setIsProductViewsFactual] = useState(false);
  const [isQuantityLeftFactual, setIsQuantityLeftFactual] = useState(false);
  const [quantityLeftFactualValue, setQuantityLeftFactualValue] = useState(1);

  const [showMessages, setShowMessages] = useState(false);
  const [showBought, setShowBought] = useState(false);
  const [showViews, setShowViews] = useState(false);
  const [showStock, setShowStock] = useState(false);
  const [stockToShow, setStockToShow] = useState(0);
  const [randomStocks, setRandomStocks] = useState([]);
  const [isMarketingKeysLoading, setIsMarketingKeysLoading] = useState(true);

  useEffect(() => {
    const fetchMarketingKeys = async () => {
      setIsMarketingKeysLoading(true);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/get_marketing_keys`,
          {
            admin_auto_id,
            app_type_id,
          },
        );

        if (response.data.status === "1" && response.data.data.length > 0) {
          const apiData = response.data.data[0];
          setIsBoughtFactual(apiData.is_bought_factual);
          setIsProductViewsFactual(apiData.is_product_views_factual);
          setIsQuantityLeftFactual(apiData.is_quantity_left_factual);
          setQuantityLeftFactualValue(apiData.quantity_left_factual_value);
        } else {
          console.error("Failed to fetch marketing keys:", response.data.msg);
        }
      } catch (error) {
        console.error("Error fetching marketing keys:", error);
      } finally {
        setIsMarketingKeysLoading(false);
      }
    };

    fetchMarketingKeys();
  }, [admin_auto_id, app_type_id]);

  useEffect(() => {
    if (isMarketingKeysLoading) {
      console.log("Waiting for marketing keys to load...");
      return;
    }

    const shouldShowMessages = Math.random() < 0.9;
    setShowMessages(shouldShowMessages);

    if (shouldShowMessages) {
      const randomChoice = Math.random();
      if (randomChoice < 0.33) {
        setShowBought(true);
        setShowViews(false);
      } else if (randomChoice < 0.66) {
        setShowBought(false);
        setShowViews(true);
      } else {
        setShowBought(true);
        setShowViews(true);
      }
    } else {
      setShowBought(false);
      setShowViews(false);
    }

    const shouldShowStock = Math.random() < 0.9;
    setShowStock(shouldShowStock);

    if (shouldShowStock) {
      const stock = parseInt(quantityLeftFactualValue, 10);

      if (isNaN(stock) || stock <= 0) {
        setRandomStocks(sizes.map(() => 0));
      } else {
        const newRandomStocks = sizes.map(
          () => Math.floor(Math.random() * stock) + 1,
        );
        setRandomStocks(newRandomStocks);
      }
    } else {
      const originalStocks = sizes.map((size) => parseInt(size.size_stock, 10));
      setRandomStocks(originalStocks);
    }
  }, [
    productsDetails.available_stock,
    sizes,
    quantityLeftFactualValue,
    isMarketingKeysLoading,
  ]);
  // New state for cross-selling products
  const [crossSellingProducts, setCrossSellingProducts] = useState([]);
  const [crossSellingLoading, setCrossSellingLoading] = useState(false);
  const [crossSellingStartIndex, setCrossSellingStartIndex] = useState(0);
  const [selectedCrossProduct, setSelectedCrossProduct] = useState(null);
  const [crossSelectedSize, setCrossSelectedSize] = useState(null);
  const [crossSelectedSizeId, setCrossSelectedSizeId] = useState(null);
  const [crossSelectedStock, setCrossSelectedStock] = useState(null);
  const [crossQuantity, setCrossQuantity] = useState(1);
  const [crossSelectedSizePrice, setCrossSelectedSizePrice] = useState(null);
  const [crossShowSizeChart, setCrossShowSizeChart] = useState(false);
  const [crossMessage, setCrossMessage] = useState(null);

  useEffect(() => {
    if (isSizeGuideModalOpen || selectedCrossProduct) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isSizeGuideModalOpen, selectedCrossProduct]);

  // Fetch cross-selling products
  useEffect(() => {
    const fetchCrossSellingProducts = async () => {
      const crossSellingIds = productsDetails.cross_selling_products
        ? productsDetails.cross_selling_products.split("|").filter((id) => id)
        : [];
      if (crossSellingIds.length === 0) {
        setCrossSellingProducts([]);
        return;
      }
      setCrossSellingLoading(true);
      try {
        const products = [];
        for (const product_auto_id of crossSellingIds) {
          const formData = new FormData();
          formData.append("admin_auto_id", admin_auto_id);
          formData.append("app_type_id", app_type_id);
          formData.append("user_auto_id", admin_auto_id);
          formData.append("product_auto_id", product_auto_id);
          formData.append("customer_auto_id", admin_auto_id);
          formData.append("sub_category_auto_id", admin_auto_id);
          const response = await fetch(
            `${process.env.REACT_APP_API_BASE_URL}/get_product_details`,
            {
              method: "POST",
              body: formData,
            },
          );
          if (!response.ok) {
            console.error(
              `Failed to fetch product details for ID: ${product_auto_id}`,
            );
            continue;
          }
          const responseData = await response.json();
          if (responseData?.get_products_details?.[0]) {
            products.push({
              ...responseData.get_products_details[0],
              images: responseData.get_products_details[0].product_images.map(
                (img) =>
                  `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${img.product_image}`,
              ),
              price: responseData.get_products_details[0].final_product_price,
              originalPrice: responseData.get_products_details[0].product_price,
              discount: `${responseData.get_products_details[0].offer_percentage}% off`,
              productAutoId:
                responseData.get_products_details[0].product_auto_id,
              name: responseData.get_products_details[0].product_name,
              user_auto_id: responseData.get_products_details[0].user_auto_id,
              description: responseData.get_products_details[0].description,
              size: responseData.get_products_details[0].size,
              get_price_lists:
                responseData.get_products_details[0].get_price_lists,
              moq: responseData.get_products_details[0].moq,
            });
          }
        }
        setCrossSellingProducts(products);
      } catch (error) {
        console.error("Error fetching cross-selling products:", error);
        setCrossSellingProducts([]);
      } finally {
        setCrossSellingLoading(false);
      }
    };
    if (productsDetails.cross_selling_products) {
      fetchCrossSellingProducts();
    }
  }, [productsDetails.cross_selling_products, admin_auto_id, app_type_id]);

  const clearCrossMessage = () => {
    setTimeout(() => {
      setCrossMessage(null);
    }, 2000);
  };

  useEffect(() => {
    if (isMarketingKeysLoading || !selectedCrossProduct) {
      return;
    }
    const shouldShowStock = Math.random() < 0.9;
    setShowStock(shouldShowStock);
    if (shouldShowStock && selectedCrossProduct.size?.length > 0) {
      const stock = parseInt(quantityLeftFactualValue, 10);
      if (isNaN(stock) || stock <= 0) {
        setRandomStocks(selectedCrossProduct.size.map(() => 0));
      } else {
        const newRandomStocks = selectedCrossProduct.size.map(
          () => Math.floor(Math.random() * stock) + 1,
        );
        setRandomStocks(newRandomStocks);
      }
    } else {
      const originalStocks = selectedCrossProduct.size.map((size) =>
        parseInt(size.size_stock, 10),
      );
      setRandomStocks(originalStocks);
    }
  }, [isMarketingKeysLoading, selectedCrossProduct, quantityLeftFactualValue]);

  const fetchCrossSizeChart = async () => {
    if (crossShowSizeChart) {
      setCrossShowSizeChart(false);
      return;
    }
    if (chartImage) {
      setCrossShowSizeChart(true);
      return;
    }
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_size_chart_list`,
        {
          admin_auto_id,
          app_type_id,
        },
      );

      if (response.data.status === "1" && response.data.getalldata.length > 0) {
        const data = response.data.getalldata;

        // Find normal size chart
        const normalChart = data.find(
          (item) => item.chart_image && item.chart_image.trim() !== "",
        );

        // Find international size chart
        const internationalChart = data.find(
          (item) =>
            item.international_size_chart &&
            item.international_size_chart.trim() !== "",
        );

        if (normalChart) {
          setChartImage(
            `https://grobizapp-n.s3.ap-south-1.amazonaws.com/SizeChart/${normalChart.chart_image}`,
          );
        }

        if (internationalChart) {
          setChartImage2(
            `https://grobizapp-n.s3.ap-south-1.amazonaws.com/SizeChart/${internationalChart.international_size_chart}`,
          );
        }

        setCrossShowSizeChart(true);
      } else {
        setCrossMessage("Size chart not available.");
      }
    } catch (error) {
      console.error("Failed to load size chart:", error);
    } finally {
      clearCrossMessage();
    }
  };

  useEffect(() => {
    if (Array.isArray(data?.product_faqs)) {
      const formattedFaqs = data.product_faqs
        .filter((item) => item?.question && item?.answer)
        .map((item) => ({
          question: item.question,
          answer: item.answer,
        }));

      setFaqs(formattedFaqs);
      console.log("FAQs:", faqs);
    }
  }, [data]); // 👈 VERY IMPORTANT

  return (
    <>
      <Helmet>
        {/* 🔹 Dynamic Title */}
        <title>
          {productsDetails?.product_name
            ? `${productsDetails.product_name} `
            : "Product Details"}
        </title>

        {/* 🔹 Meta Description */}
        <meta
          name="description"
          content={
            productsDetails?.description
              ? productsDetails.description.replace(/(<([^>]+)>)/gi, "")
              : "Buy products online at best price."
          }
        />

        {/* 🔹 Keywords */}
        <meta
          name="keywords"
          content={
            productsDetails?.keywords
              ? productsDetails.keywords
              : "online shopping, ecommerce product"
          }
        />

        {/* 🔹 PRODUCT SCHEMA (JSON-LD) */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Product",
            name: productsDetails?.product_name,
            description: productsDetails?.description
              ?.replace(/(<([^>]+)>)/gi, "")
              .slice(0, 160),
            image: productsDetails?.product_images?.map(
              (img) =>
                `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${img.product_image}`,
            ),
            offers: {
              "@type": "Offer",
              priceCurrency: "INR",
              price: productsDetails?.final_product_price,
              availability:
                productsDetails?.available_stock > 0
                  ? "https://schema.org/InStock"
                  : "https://schema.org/OutOfStock",
            },
          })}
        </script>
      </Helmet>
      <style>
        {`
          /* Move dots to bottom-left */
.swiper-pagination {
  bottom: 10px !important;
  left: 10px !important;
  text-align: left !important; /* align bullets to left */
}

/* Inactive dot */
.swiper-pagination-bullet {
  background: #ffffff !important;
  opacity: 0.5;
}

/* Active dot */
.swiper-pagination-bullet-active {
  background: #000000 !important;
  opacity: 1;
}

          @keyframes wiggle {
            0%, 100% { transform: translateX(0); }
            25% { transform: translateX(-3px); }
            50% { transform: translateX(3px); }
            75% { transform: translateX(-3px); }
          }
          .wiggle {
            animation: wiggle 0.2s ease-in-out 3;
          }

           .disabled-overlay::after {
            content: "";
            position: absolute;
            top: 50%;
            left: 8%;
            right: 8%;
            height: 1px;
            background-color: #9ca3af; /* gray-400 */
            transform: translateY(-50%);
            pointer-events: none;
          }
        `}
      </style>
      <div className="block w-full md:hidden">
        <Swiper
          modules={[Pagination]} // ← REQUIRED
          spaceBetween={10}
          pagination={{ clickable: true }}
          loop={true}
          className="relative w-full h-auto"
        >
          {Array.isArray(productImages) &&
            productImages.map((img, index) => (
              <SwiperSlide key={index}>
                <img
                  src={
                    img?.product_image && img.product_image.trim() !== ""
                      ? `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${img.product_image}`
                      : "https://placehold.co/480x600"
                  }
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "https://placehold.co/480x600";
                  }}
                  alt="product"
                  className="w-full h-[480px] object-cover"
                />

              </SwiperSlide>
            ))}
        </Swiper>
      </div>

      <div
        className={`max-w-full text-black bg-white ${webFont}`}
        style={{ fontFamily: "" }}
      >
        {/* Product Display Section */}
        <div className="flex flex-col max-w-6xl gap-8 px-4 mx-auto sm:py-10 sm:px-6 lg:px-8 lg:flex-row">
          {/* Left Section (Thumbnails & Main Image) - Increased Width */}
          <div className="flex gap-1 ">
            {/* Left: Image Thumbnails */}
            <div className="flex flex-col hidden space-y-3 md:block">
              {Array.isArray(productImages) && productImages.length > 0 ? (
                productImages.map((thumb, index) => (
                  <img
                    key={thumb.image_auto_id || index}
                    src={
                      thumb?.product_image && thumb.product_image.trim() !== ""
                        ? `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${thumb.product_image}`
                        : "https://placehold.co/100x150"
                    }

                    alt={`Thumbnail ${thumb + 1}`}
                    className={`w-20 h-28 border rounded cursor-pointer 
                                    ${mainImage === thumb
                        ? "border-2 border-black"
                        : "border"
                      }`} // Apply black border if active
                    onClick={() => setMainImage(thumb)} // Update main image when thumbnail is clicked
                  />
                ))
              ) : (
                <p>No images available</p>
              )}
            </div>

            {/* Middle: Enlarged Main Product Image */}
            <div className="flex flex-col items-center justify-center flex-1 hidden mb-auto md:block">
              {mainImage && mainImage.product_image ? (
                /* Wrapper gives us overflow clipping + cursor‑follow transform‑origin */
                <div
                  className="overflow-hidden border border-black rounded-md cursor-zoom-in"
                  onMouseMove={(e) => {
                    const rect = e.currentTarget.getBoundingClientRect();
                    const x = ((e.clientX - rect.left) / rect.width) * 100;
                    const y = ((e.clientY - rect.top) / rect.height) * 100;
                    // first (and only) child is the img element
                    e.currentTarget.children[0].style.transformOrigin = `${x}% ${y}%`;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.children[0].style.transformOrigin =
                      "center";
                  }}
                >
                  <img
                    src={
                      mainImage?.product_image && mainImage.product_image.trim() !== ""
                        ? `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${mainImage.product_image}`
                        : "https://placehold.co/600x800"
                    }
                    onError={(e) => {
                      e.target.src = "https://placehold.co/600x800"
                    }}

                    alt={mainImage.product_image}
                    className="object-cover w-full max-w-[750px] h-[800px] transition-transform duration-300 ease-in-out hover:scale-[2.5]"
                  />
                </div>
              ) : (
                <p>Image not available</p>
              )}
            </div>
          </div>

          {/* Right Section - Reduced Width */}
          <div className="flex-1 ml-1">
            {/* Title and Price */}
            <div>
              <h1 className="inline-block text-xl font-bold text-gray-800">
                {productsDetails.product_name}
              </h1>
              <p className="mb-0 text-gray-500">
                SKU: {formatSKU(productsDetails.product_model_auto_id)}
              </p>
              <div className="flex items-center">
                {/* Clickable Stars */}
                <button className="text-black cursor-pointer">
                  {renderStars(averageRating)}
                </button>

                <span className="ml-2 text-sm text-gray-500">
                  ({averageRating})
                </span>
              </div>

              <div className="mt-1">
                {showBought && isBoughtFactual && (
                  <p className="flex items-center text-sm font-medium font-extrabold text-black">
                    {boughtCount}+ bought this !
                  </p>
                )}
              </div>
              <p className="text-xl font-semibold">
                ₹ {currentPrice}
                {parseInt(currentOffer) > 0 && (
                  <>
                    {" "}
                    <span className="ml-2 text-gray-400 line-through">
                      ₹ {originalPrice}
                    </span>
                    <span
                      className="px-2 py-1 ml-2 text-sm text-white rounded-full"
                      style={{ backgroundColor: themeColor }}
                    >
                      {currentOffer}% OFF
                    </span>
                  </>
                )}
              </p>
              <p className="text-sm text-gray-500">
                {productsDetails.including_tax === "Yes"
                  ? "Inclusive of all taxes"
                  : "Exclusive of all taxes"}
              </p>
            </div>

            {/* Color and Size Selector */}
            <div className="space-y-4">
              {colors && colors.length > 0 && (
                <div className="flex flex-col space-y-1">
                  <label className="text-sm font-medium text-gray-700">
                    Color:
                  </label>
                  <div className="flex mt-1 space-x-2">
                    {colors.map((color) => (
                      <Link
                        to={`/product-detail/${color.product_auto_id}`}
                        key={color.product_auto_id}
                        className="w-8 h-8 border border-gray-300 rounded-full shadow-sm cursor-pointer"
                        style={{
                          backgroundColor: color.color_code
                            ? color.color_code
                              .replace("Color(0xff", "#")
                              .replace(")", "")
                            : "#000000", // Fallback color if color_code is null/undefined
                        }}
                        title={color.color_name}
                      />
                    ))}
                  </div>
                </div>
              )}

              {colors && colors.length > 0 && (
                <div className="flex flex-col mt-4 space-y-2">
                  <label className="text-sm font-medium text-gray-700">
                    Color:
                  </label>
                  <div className="flex mt-2 space-x-3">
                    {colors.map((color) => {
                      const imageUrl = color.color_image
                        ? `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${color.color_image}`
                        : 'https://via.placeholder.com/400x400?text=No+Image';
                      return (
                        <Link
                          to={`/product-detail/${color.product_auto_id}`}
                          key={color.product_auto_id}
                          className="relative w-16 overflow-hidden transition-all duration-200 border-2 shadow-md cursor-pointer h-28"
                          title={color.color_name}
                          onClick={() => console.log(`Attempting to load image: ${imageUrl}`)}
                          style={{ borderColor: lightenHexColor(themeColor, 0.2) }}
                          onMouseEnter={(e) => {
                            const darkenedColor = darkenHexColor(themeColor, 0.15);
                            e.currentTarget.style.borderColor = darkenedColor;
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.borderColor = lightenHexColor(themeColor, 0.2);
                          }}

                        >
                          <img
                            src={imageUrl}
                            alt={color.color_name || 'Color Image'}
                            className="object-cover w-full h-full"
                            onError={(e) => {
                              console.error(`Failed to load image: ${imageUrl}`);
                              e.target.src = 'https://via.placeholder.com/400x400?text=Image+Failed';
                            }}
                          />

                        </Link>
                      );
                    })}
                  </div>
                </div>
              )}

              {sizes && sizes.length > 0 && (
                <>
                  <div className="relative">
                    <label className="block mb-2 text-sm font-medium text-gray-700 ">
                      Select:
                    </label>

                    {/* Size Guide Button Positioned in Top-Right Corner */}
                    {(chartImage || chartImage2) && (
                      <button
                        className="absolute top-0 right-0 pr-2 text-sm text-teal-800 hover:underline rounded-r-2xl"
                        onClick={toggleSizeGuideModal}
                      >
                        Size Guide
                      </button>
                    )}

                    {/* Sidebar Modal */}
                    {isSizeGuideModalOpen && (
                      <div className="fixed inset-0 z-50 flex justify-end">
                        {/* Click Outside to Close */}
                        <div
                          className="flex-1 bg-black bg-opacity-50"
                          onClick={toggleSizeGuideModal}
                        ></div>

                        <div className="w-[360px] h-full bg-white shadow-lg p-6 overflow-y-auto relative transition-transform duration-300">
                          {/* Close Button */}
                          <button
                            onClick={toggleSizeGuideModal}
                            className="absolute text-gray-600 top-4 right-4 hover:text-black"
                          >
                            <X size={24} />
                          </button>

                          {/* Title */}
                          <h2 className="mb-2 text-2xl font-bold text-center">
                            Size Guide
                          </h2>

                          {/* Tabs */}
                          <div className="flex mb-4 border-b">
                            <button
                              onClick={() => setSelectedTab("Size Chart")}
                              className={`flex-1 py-2 font-semibold ${selectedTab === "Size Chart"
                                ? "border-b-2"
                                : "text-gray-600"
                                }`}
                              style={{
                                borderColor: themeColor,
                                color: themeColor,
                              }}
                            >
                              Size Chart
                            </button>

                            {chartImage2 && (
                              <button
                                onClick={() => setSelectedTab("International")}
                                className={`flex-1 py-2 font-semibold ${selectedTab === "International"
                                  ? "border-b-2"
                                  : "text-gray-600"
                                  }`}
                                style={{
                                  borderColor: themeColor,
                                  color: themeColor,
                                }}
                              >
                                International
                              </button>
                            )}
                          </div>

                          {/* Chart Content */}
                          {selectedTab === "Size Chart" && (
                            <div className="space-y-2">
                              {chartImage ? (
                                <img
                                  src={chartImage}
                                  alt="Size Chart"
                                  className="w-full transition-transform duration-300 border rounded-md shadow-sm"
                                />
                              ) : (
                                <p className="text-sm text-center text-gray-500">
                                  Chart not available.
                                </p>
                              )}
                            </div>
                          )}

                          {/* International Chart Content */}
                          {selectedTab === "International" && (
                            <div className="space-y-2">
                              {chartImage2 ? (
                                <img
                                  src={chartImage2}
                                  alt="International Size Chart"
                                  className="w-full transition-transform duration-300 border rounded-md shadow-sm"
                                />
                              ) : (
                                <p className="text-sm text-center text-gray-500">
                                  Internationalimage not available.
                                </p>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                    {/* Choose Size Dropdown with Black Border & Rounded Corners */}

                    {/* <select
                      className="block w-full px-2 py-2 mt-1 border border-black shadow-sm rounded-2xl focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                      onChange={(e) => {
                        const selectedIndex = e.target.selectedIndex - 1; // -1 to account for "Choose Size" option
                        if (selectedIndex >= 0) {
                          handleSizeSelect(sizes[selectedIndex], selectedIndex);
                        }
                      }}
                    >
                      <option>choose</option>
                      {sizes.map((size, index) => (
                        <option key={size.size_auto_id} value={size.size_name}>
                          {size.size_name}
                        </option>
                      ))}
                    </select> */}

                    <div className="flex mt-4 space-x-2">
                      {sizes.map((size, index) => {
                        const actualStock = parseInt(size.size_stock, 10);
                        const isDisabled =
                          !actualStock ||
                          isNaN(actualStock) ||
                          actualStock <= 0;
                        const isSelected = selectedSize === size.size_name;

                        const displayStock = showStock
                          ? randomStocks[index]
                          : actualStock;
                        const showStockLabel =
                          actualStock > 0 &&
                          showStock &&
                          isQuantityLeftFactual &&
                          displayStock <= 5;

                        return (
                          <div key={size.product_auto_id} className="relative">
                            <button
                              className={`relative border w-12 h-12 sm:w-20 rounded-full text-sm flex items-center justify-center flex-col transition-colors duration-200 overflow-hidden
            ${isDisabled ? "bg-gray-200 text-gray-400 border-gray-300 cursor-not-allowed" : ""}
            ${!isDisabled && isSelected ? "text-white" : ""}
          `}
                              style={{
                                backgroundColor:
                                  !isDisabled && isSelected
                                    ? themeColor
                                    : undefined,
                                borderColor:
                                  !isDisabled && isSelected
                                    ? themeColor
                                    : undefined,
                                color:
                                  !isDisabled && isSelected
                                    ? "#ffffff"
                                    : undefined,
                              }}
                              onClick={() =>
                                !isDisabled && handleSizeSelect(size, index)
                              }
                              disabled={isDisabled}
                            >
                              {/* SIZE TEXT */}
                              <span
                                className={`text-base leading-none ${showStockLabel ? "mb-3" : ""}`}
                              >
                                {size.size_name}
                              </span>

                              {/* STOCK LABEL */}
                              {showStockLabel && (
                                <span
                                  className="absolute bottom-0 left-0 right-0 px-2 py-[4px] text-[11px] text-center text-white leading-tight"
                                  style={{ backgroundColor: themeColor }}
                                >
                                  {displayStock} left
                                </span>
                              )}

                              {/* 🔥 ADDED: Slash Line When Disabled */}
                              {isDisabled && (
                                <span
                                  className="absolute w-[140%] h-[1px] bg-gray-400 left-1/2 top-1/2 pointer-events-none"
                                  style={{
                                    transform:
                                      "translate(-50%, -50%) rotate(35deg)",
                                  }}
                                ></span>
                              )}
                            </button>
                          </div>
                        );
                      })}
                    </div>

                    {showStock &&
                      isQuantityLeftFactual &&
                      sizes.length > 0 &&
                      stockToShow >= 1 &&
                      stockToShow <= 5 && (
                        <p className="flex justify-center mt-2 text-sm font-bold text-gray-400 items center">
                          <span className="mr-1">
                            <AiOutlineThunderbolt size={18} />
                          </span>
                          Hurry! Only {stockToShow} left
                        </p>
                      )}
                  </div>
                </>
              )}
            </div>

            <div className="mt-4">
              <p className="flex items-center font-semibold text-gray-500">
                <FaMapMarkerAlt className="mr-2" size={18} /> Check Availability
              </p>
              <div className="flex items-center mt-2">
                <input
                  type="text"
                  placeholder="Enter pincode"
                  value={pincode}
                  onChange={handlePincodeChange}
                  className="w-full px-2 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                  maxLength={8} // Allow up to 8 digits
                  disabled={loading}
                />
              </div>
              {loading && (
                <p className="mt-2 text-sm font-medium text-gray-600">
                  Checking...
                </p>
              )}
              {message && (
                <p className={`mt-2 text-sm font-medium ${messageColor}  p-2 `}>
                  {message}
                </p>
              )}
            </div>

            {isCustomizable && (
              <div className="mt-4 mb-2">
                <p className="flex items-center font-semibold text-gray-500">
                  <span className="mr-2">📷</span> Customize Your Product
                </p>
                <div className="p-4 mt-2 border border-gray-300 rounded-lg bg-gray-50">
                  <p className="mb-2 text-sm text-gray-600">
                    Upload an image to personalize your{" "}
                    {productsDetails.product_name}
                  </p>
                  <div className="flex items-center gap-4">
                    <input
                      type="file"
                      accept="image/*"
                      ref={fileInputRef}
                      onChange={handleImageUpload}
                      className="hidden"
                      id="image-upload"
                    />
                    <label
                      htmlFor="image-upload"
                      className="px-4 py-2 text-white transition duration-200 rounded-lg cursor-pointer "
                      style={{ backgroundColor: themeColor }}
                      onMouseEnter={(e) => {
                        const darkenedColor = lightenHexColor(themeColor, 0.1);
                        e.currentTarget.style.backgroundColor = darkenedColor;
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = themeColor;
                      }}
                    >
                      Choose Image
                    </label>
                    {imagePreview && (
                      <div className="flex items-center gap-2">
                        <img
                          src={imagePreview}
                          alt="Preview"
                          className="object-cover w-16 h-16 border border-gray-300 rounded-md"
                        />
                        <button
                          onClick={handleRemoveImage}
                          className="p-1 text-red-500 transition bg-gray-100 rounded-full hover:text-red-700 hover:bg-gray-200"
                          aria-label="Remove uploaded image"
                        >
                          <FaTimes size={16} />
                        </button>
                      </div>
                    )}
                  </div>
                  {uploadedImage && (
                    <p className="mt-2 text-sm text-green-600">
                      Image uploaded: {uploadedImage.name}
                    </p>
                  )}
                  <p className="mt-2 text-xs text-gray-500">
                    Supported formats: JPG, PNG, GIF.
                  </p>
                </div>
              </div>
            )}
            {/* Buttons */}
            <div className="flex flex-col space-y-4">
              <div className="relative mt-4">
                {cartMessage.text && (
                  <div
                    className={`absolute left-0 right-0 top-[-1.5rem] text-center p-2 text-sm z-10 ${cartMessage.type === "error"
                      ? "text-red-500"
                      : "text-green-500"
                      }`}
                  >
                    {cartMessage.text}
                  </div>
                )}
                {wishlistMessage.text && (
                  <div
                    className={`absolute left-0 right-0 top-[-1.5rem] text-center p-2 text-sm z-10 ${wishlistMessage.type === "error"
                      ? "text-red-500"
                      : "text-green-500"
                      }`}
                  >
                    {wishlistMessage.text}
                  </div>
                )}
                <button
                  className={`block mt-4 w-full px-20 py-2 rounded-2xl font-semibold flex items-center justify-center gap-2 transition-colors duration-200 ${sizes?.length > 0 && !selectedSize
                    ? " bg-gray-400 text-white cursor-not-allowed"
                    : " text-white "
                    }`}
                  style={{
                    backgroundColor:
                      sizes?.length > 0 && !selectedSize ? "" : themeColor,
                  }}
                  onMouseEnter={(e) => {
                    const darkenedColor = darkenHexColor(themeColor, 0.15); // darken by 15%
                    e.currentTarget.style.backgroundColor =
                      sizes?.length > 0 && !selectedSize ? "" : darkenedColor;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor =
                      sizes?.length > 0 && !selectedSize ? "" : themeColor;
                  }}
                  onClick={async () => {
                    if (sizes?.length === 0 || selectedSize) {
                      try {
                        const payload = {
                          product_auto_id: productsDetails?.product_auto_id,
                          added_by_id: productsDetails?.user_auto_id,
                          cart_quantity:
                            productsDetails?.moq && productsDetails.moq !== ""
                              ? productsDetails.moq
                              : 1,
                          ...(sizes?.length !== 0 && {
                            size: selectedSizeId,
                            size_price: currentPrice,
                          }),
                          ...(isCustomizable && uploadedImage && { cust_image: uploadedImage }),
                        };

                        const res = await addToCart(payload);

                        // 🚫 ALREADY IN CART (check message FIRST)
                        if (res?.message && res.message.toLowerCase().includes("already")) {
                          setCartMessage({
                            text: "Product is already present in cart",
                            type: "error",
                          });
                          return;
                        }

                        // ✅ SUCCESS
                        if (res?.status === "1") {
                          setCartMessage({
                            text: res.message || "Added to cart",
                            type: "success",
                          });

                          setTimeout(() => {
                            navigate("/cart");
                          }, 1000);
                        } else {
                          setCartMessage({
                            text: res?.message || "Unable to add product to cart",
                            type: "error",
                          });
                        }

                      } catch (error) {
                        setCartMessage({
                          text: error.message || "Failed to add product to cart.",
                          type: "error",
                        });
                      }
                    } else {
                      setCartMessage({ text: "Select a Size", type: "error" });
                      return;
                    }
                  }}

                  disabled={sizes?.length > 0 && !selectedSize}
                >
                  <GiShoppingBag className="w-4 h-4" />
                  {sizes?.length > 0 && !selectedSize
                    ? "Select Size"
                    : `Add | ₹ ${currentPrice}`}
                </button>
              </div>
              <button
                onClick={handleWishlistToggle}
                className={`flex items-center justify-center gap-2 border mt-2 mb-3 w-full px-20 py-2 rounded-2xl transition-colors
    ${wishlisted ? "text-white" : "border-black text-black"}
    ${isVibrating ? "wiggle" : ""}
  `}
                style={{
                  backgroundColor: wishlisted ? themeColor : "",
                  borderColor: wishlisted ? themeColor : "",
                }}
              >
                {wishlisted ? (
                  <FaHeart className="text-red-600" />
                ) : (
                  <FiHeart />
                )}
                {wishlisted ? "Favourited" : "Favourite"}
              </button>


              <div className="mt-2 space-y-2">
                {showViews && isProductViewsFactual && (
                  <p className="flex items-center justify-center text-sm font-medium text-black">
                    <IoEyeSharp className="mr-1" size={18} />
                    {getRandomViewCount(productsDetails.view_count)} people are
                    viewing this item. Don’t wait!
                  </p>
                )}
              </div>

              {crossSellingProducts.length > 0 && (
                <div className={`flex flex-col mt-4 space-y-2 ${webFont}`}>
                  <label className="text-sm font-medium text-gray-700">
                    Model is also wearing:
                  </label>
                  <div className="flex mt-2 space-x-3">
                    {crossSellingProducts.map((product) => {
                      const imageUrl =
                        product.images?.length > 0
                          ? product.images[0]
                          : "https://via.placeholder.com/400x400?text=No+Image";
                      return (
                        <div
                          key={product.productAutoId}
                          className="relative flex flex-col items-center w-24 overflow-visible transition-all duration-200 cursor-pointer"
                          title={product.name}
                          onClick={() => setSelectedCrossProduct(product)}
                        >
                          <img
                            src={imageUrl}
                            alt={product.name || "Product Image"}
                            className="object-cover w-full h-28"
                            onError={(e) => {
                              console.error(
                                `Failed to load image: ${imageUrl}`,
                              );
                              e.target.src =
                                "https://via.placeholder.com/400x400?text=Image+Failed";
                            }}
                          />
                          <p className="w-full mt-1 text-xs text-center text-gray-700 break-words truncate">
                            {product.name}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>

            {/* Description */}
            {productsDetails.description && (
              <div className="relative p-3 bg-white border-t border-b border-gray-200">
                {productsDetails.description.split(" ").length > 20 ? (
                  <div>
                    <p className="text-sm text-gray-500">
                      {isDescriptionExpanded
                        ? productsDetails.description
                        : `${productsDetails.description.split(" ").slice(0, 20).join(" ")}...`}
                    </p>
                    <button
                      className="absolute text-sm underline transition-colors duration-200 bottom-2 right-2"
                      style={{ color: themeColor }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.color = darkenHexColor(
                          themeColor,
                          0.15,
                        );
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.color = themeColor;
                      }}
                      onClick={() =>
                        setIsDescriptionExpanded(!isDescriptionExpanded)
                      }
                      aria-expanded={isDescriptionExpanded}
                    >
                      {isDescriptionExpanded ? "Read Less" : "Read More"}
                    </button>
                  </div>
                ) : (
                  <p className="text-sm text-gray-500">
                    {productsDetails.description}
                  </p>
                )}
              </div>
            )}

            {/* More From This Brand */}
          </div>
        </div>
      </div>

      <div></div>
      {/* customer reviws */}
      <div className={`p-6 mx-auto max-w-7xl ${webFont}`}>
        <h2 className="text-2xl font-semibold">Reviews</h2>
        <div className="grid grid-cols-1 my-3 md:grid-cols-3">
          <div className="p-6 bg-gray-100 rounded-lg">
            <div className="flex items-center gap-4">
              {/* <div className="w-20 h-20 bg-gray-300 rounded-full"></div> */}
              <div>
                <p className="text-xl font-bold">{avgRating} / 5</p>
                <p className="text-sm text-gray-500">
                  ({totalReviews} reviews)
                </p>
              </div>
            </div>
            <div className="mt-6">
              <p className="text-lg font-semibold">Review Summary</p>
              <div className="mt-3 space-y-2">
                <p className="text-base text-black underline">
                  5 Stars ({ratingSummary[5]})
                </p>
                <div className="w-full h-2 bg-gray-300 rounded-lg">
                  <div
                    className="h-2 bg-teal-600 rounded-lg"
                    style={{
                      width: totalReviews
                        ? `${(ratingSummary[5] / totalReviews) * 100}%`
                        : "0%",
                    }}
                  ></div>
                </div>
                <p className="text-base text-black underline">
                  4 Stars ({ratingSummary[4]})
                </p>
                <div className="w-full h-2 bg-gray-300 rounded-lg">
                  <div
                    className="h-2 bg-teal-600 rounded-lg"
                    style={{
                      width: totalReviews
                        ? `${(ratingSummary[4] / totalReviews) * 100}%`
                        : "0%",
                    }}
                  ></div>
                </div>
                <p className="text-base text-black underline">
                  3 Stars ({ratingSummary[3]})
                </p>
                <div className="w-full h-2 bg-gray-300 rounded-lg">
                  <div
                    className="h-2 bg-teal-600 rounded-lg"
                    style={{
                      width: totalReviews
                        ? `${(ratingSummary[3] / totalReviews) * 100}%`
                        : "0%",
                    }}
                  ></div>
                </div>
                <p className="text-base text-gray-400">
                  2 Stars ({ratingSummary[2]})
                </p>
                <div className="w-full h-2 bg-gray-300 rounded-lg">
                  <div
                    className="h-2 bg-teal-600 rounded-lg"
                    style={{
                      width: totalReviews
                        ? `${(ratingSummary[2] / totalReviews) * 100}%`
                        : "0%",
                    }}
                  ></div>
                </div>
                <p className="text-base text-gray-400">
                  1 Stars ({ratingSummary[1]})
                </p>
                <div className="w-full h-2 bg-gray-300 rounded-lg">
                  <div
                    className="h-2 bg-teal-600 rounded-lg"
                    style={{
                      width: totalReviews
                        ? `${(ratingSummary[1] / totalReviews) * 100}%`
                        : "0%",
                    }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-span-2 ml-4">
            {reviews.slice(0, visibleReviews).map((review, index) => (
              <div
                key={index}
                className="grid items-center grid-cols-3 py-4 border-b"
              >
                <div>
                  <span className="text-lg text-black">
                    {"★".repeat(review.rating)}
                    <span className="text-gray-300">
                      {"★".repeat(5 - review.rating)}
                    </span>
                  </span>
                  <p className="text-sm text-gray-500">{review.date}</p>
                </div>
                <div>
                  <p className="text-base">{review.text}</p>
                </div>
                <div className="ml-10">
                  <p className="font-semibold">{review.user}</p>
                  {review.location && (
                    <p className="text-sm text-gray-500">{review.location}</p>
                  )}
                  {review.verified && (
                    <span className="inline-block px-3 py-1 mt-2 text-xs text-white bg-teal-600 rounded-full">
                      Verified
                    </span>
                  )}
                </div>
              </div>
            ))}
            {visibleReviews < reviews.length && (
              <div className="flex justify-center mt-6">
                <button
                  className="px-4 py-2 text-lg text-black transition duration-300 border-black border-1 rounded-3xl hover:bg-gray-800 hover:text-white"
                  onClick={() => setVisibleReviews(visibleReviews + 5)}
                >
                  View More Reviews
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <div
        className={`relative flex flex-col items-center  mt-4 mb-4 text-center ${webFont}`}
      >
        {/* Heading and Clear Button Centered */}
        <div className="flex items-center justify-between w-full max-w-6xl px-4 mb-3">
          <h4 className="font-medium text-gray-800">Similar Products</h4>
        </div>

        {/* Slider Container */}
        <div className="w-full max-w-6xl">
          <Slider
            {...{
              ...sliderSettings,
              responsive: [
                {
                  breakpoint: 768, // MOBILE ONLY
                  settings: {
                    slidesToShow: 2.5,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: false,
                  },
                },
              ],
            }}
          >
            {relatedProducts.map((product) => (
              <div key={product.product_auto_id} className="px-2 mobile-card">
                <Link
                  to={`/product-detail/${product.product_auto_id}`}
                  className="no-underline text-inherit"
                >
                  <div className="flex flex-col items-center">
                    {/* Product Image - Show only first image */}

                    <div className="flex items-center justify-center w-full h-48 mb-2 overflow-hidden bg-gray-100 rounded-lg">
                      <img
                        src={
                          product.product_images?.[0]?.product_image &&
                            product.product_images[0].product_image.trim() !== ""
                            ? `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${product.product_images[0].product_image}`
                            : "https://placehold.co/300x400"
                        }
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = "https://placehold.co/300x400";
                        }}
                        alt={product.product_name}
                        className="object-contain w-full h-full"
                      />
                    </div>


                    {/* Product Info */}
                    <div className="w-full p-1 text-center">
                      <h3 className="mb-0 text-sm font-medium text-gray-900 truncate line-clamp-2">
                        {product.product_name}
                      </h3>

                      <p className="text-sm text-center text-gray-800 md:text-base">
                        <span className="mr-4 font-bold">
                          Rs. {product.final_product_price}
                        </span>

                        {product.offer_percentage > 0 && (
                          <span className="text-gray-500 line-through">
                            Rs. {product.product_price}
                          </span>
                        )}
                      </p>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </Slider>
        </div>
      </div>

      {selectedCrossProduct && (
        <div className="fixed inset-0 z-40 flex justify-end bg-opacity-30 backdrop-blur-sm">
          {/* Left side: Vertically scrollable images */}
          <div className="w-1/2 sm:w-[600px] h-full overflow-y-auto">
            {selectedCrossProduct.images &&
              selectedCrossProduct.images.length > 0 ? (
              selectedCrossProduct.images.map((image, index) => (
                <div key={index} className="w-full h-full mb-2">
                  <img
                    src={image}
                    alt={`${selectedCrossProduct.name} ${index + 1}`}
                    className="object-cover w-full h-full"
                  />
                </div>
              ))
            ) : (
              <div className="w-full h-[400px]">
                <img
                  src="https://placehold.co/600x400"
                  alt="No image available"
                  className="object-cover w-full h-full"
                />
              </div>
            )}
          </div>
          {/* Right side: Existing content */}
          <div className="w-1/2 sm:w-[500px] h-full bg-white shadow-lg transform transition-transform z-50 flex flex-col">
            <div className="flex items-center justify-between px-4 py-3">
              <p
                className="mb-0 text-lg font-bold text-black"
                onClick={() => setSelectedCrossProduct(null)}
              >
                CHOOSE OPTION
              </p>
              <button
                className="text-xl text-gray-500"
                onClick={() => setSelectedCrossProduct(null)}
              >
                <LiaTimesSolid />
              </button>
            </div>
            <div className="w-full h-px bg-gray-400"></div>
            <div className="relative flex-1 py-3 pl-10 pr-3 overflow-y-auto">
              <h2 className="text-lg font-bold truncate">
                {selectedCrossProduct.name}
              </h2>
              <p className="mt-2 text-gray-600 truncate">
                {selectedCrossProduct.description}
              </p>
              <div className="flex items-center justify-start mt-1">
                <span className="mr-3 text-lg font-semibold">
                  {`Rs. ${crossSelectedSizePrice ? crossSelectedSizePrice : selectedCrossProduct.price}`}
                </span>
                {selectedCrossProduct.discount &&
                  parseFloat(
                    selectedCrossProduct.discount.replace("% off", ""),
                  ) > 0 && (
                    <span className="text-sm text-gray-500 line-through">
                      {selectedCrossProduct.originalPrice}
                    </span>
                  )}
              </div>
              {selectedCrossProduct.size?.length > 0 && (
                <>
                  <div className="mt-3">
                    <div className="flex items-center justify-between">
                      <label className="font-bold">Select</label>
                      {(chartImage || chartImage2) && (
                        <div className="text-end">
                          <button
                            className="flex items-center justify-end gap-1 mt-2 text-black"
                            onClick={fetchCrossSizeChart}
                          >
                            <TfiRulerAlt className="text-base" />
                            {crossShowSizeChart ? (
                              <span className="underline">Size Chart</span>
                            ) : (
                              <span className="underline">Size Chart</span>
                            )}
                          </button>
                        </div>
                      )}
                    </div>
                    <div className="flex gap-2 mt-2">
                      {Array.isArray(selectedCrossProduct?.size) &&
                        selectedCrossProduct.size.map((sizeObj, index) => {
                          const actualStock = parseInt(sizeObj.size_stock, 10);
                          const isDisabled =
                            !actualStock ||
                            isNaN(actualStock) ||
                            actualStock <= 0;
                          const isSelected =
                            crossSelectedSize === sizeObj.size_name;
                          const displayStock = showStock
                            ? randomStocks[index]
                            : actualStock;
                          const showStockLabel =
                            actualStock > 0 &&
                            showStock &&
                            isQuantityLeftFactual &&
                            displayStock <= 5;
                          return (
                            <div
                              key={sizeObj.size_auto_id}
                              className="relative"
                            >
                              <button
                                className={`relative border w-20 h-12 rounded-full text-sm flex items-center justify-center flex-col transition-colors duration-200 overflow-hidden
                                        ${isDisabled ? "bg-gray-200 text-gray-400 border-gray-300 cursor-not-allowed disabled-overlay" : ""}
                                        ${!isDisabled && isSelected ? "text-white" : ""}`}
                                style={{
                                  backgroundColor:
                                    !isDisabled && isSelected
                                      ? themeColor
                                      : undefined,
                                  borderColor:
                                    !isDisabled && isSelected
                                      ? themeColor
                                      : undefined,
                                  color:
                                    !isDisabled && isSelected
                                      ? "#ffffff"
                                      : undefined,
                                }}
                                onClick={() => {
                                  if (isDisabled) return;
                                  setCrossSelectedSize(sizeObj.size_name);
                                  setCrossSelectedSizeId(sizeObj.size_auto_id);
                                  setCrossSelectedStock(actualStock);
                                  const sizePriceObj =
                                    selectedCrossProduct.get_price_lists[index];
                                  if (
                                    !sizePriceObj ||
                                    !sizePriceObj.final_size_price
                                  ) {
                                    setCrossMessage("Size price not available");
                                    clearCrossMessage();
                                    return;
                                  }
                                  setCrossSelectedSizePrice(
                                    sizePriceObj.final_size_price,
                                  );
                                }}
                                onMouseEnter={(e) => {
                                  if (!isSelected && !isDisabled) {
                                    e.currentTarget.style.backgroundColor =
                                      themeColor;
                                    e.currentTarget.style.color = "#ffffff";
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  if (!isSelected && !isDisabled) {
                                    e.currentTarget.style.backgroundColor =
                                      "#ffffff";
                                    e.currentTarget.style.color = "#000000";
                                  }
                                }}
                                disabled={isDisabled}
                              >
                                <span
                                  className={`text-base leading-none ${showStockLabel ? "mb-3" : ""}`}
                                >
                                  {sizeObj.size_name}
                                </span>
                                {showStockLabel && (
                                  <span
                                    className="absolute bottom-0 left-0 right-0 px-2 py-[4px] text-[11px] text-center text-white leading-tight"
                                    style={{ backgroundColor: themeColor }}
                                  >
                                    {displayStock} left
                                  </span>
                                )}
                              </button>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                  {crossShowSizeChart && chartImage && (
                    <div className="p-2 mt-2 border rounded-lg">
                      <h3 className="mb-2 text-lg font-bold">Size Chart</h3>
                      <img
                        src={chartImage}
                        alt="Size Chart"
                        className="w-full h-auto rounded"
                      />
                      <h3 className="mb-2 text-lg font-bold">
                        International Size Chart
                      </h3>
                      <img
                        src={chartImage2}
                        alt="Size Chart"
                        className="w-full h-auto rounded"
                      />
                    </div>
                  )}
                </>
              )}
              <div className="relative mt-5">
                {crossMessage && (
                  <div
                    className="p-2 mt-2 text-sm text-center bg-white"
                    style={{
                      color: crossMessage.includes("successfully")
                        ? "green"
                        : "red",
                    }}
                  >
                    {crossMessage}
                  </div>
                )}
                <div className="flex flex-row items-center gap-1">
                  <div className="flex items-center">
                    <button
                      className="bg-white px-2 py-[12px] border-l-2 border-t-2 border-b-2 border-gray-200 rounded-l-full"
                      onClick={() =>
                        setCrossQuantity(Math.max(1, crossQuantity - 1))
                      }
                    >
                      <FaMinus />
                    </button>
                    <input
                      type="number"
                      min="1"
                      value={crossQuantity}
                      onChange={(e) => {
                        const value = Math.max(1, parseInt(e.target.value));
                        setCrossQuantity(value);
                      }}
                      className="w-11 text-center border-t-2 border-b-2 border-gray-200 py-[8px] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none appearance-none"
                    />
                    <button
                      className="bg-white px-2 py-[12px] border-r-2 border-t-2 border-b-2 border-gray-200 rounded-r-full"
                      onClick={() => setCrossQuantity(crossQuantity + 1)}
                    >
                      <FaPlus />
                    </button>
                  </div>
                  <button
                    className={`flex-1 text-white py-[12px] rounded-full border ${selectedCrossProduct.size?.length > 0 && (!crossSelectedSize || crossSelectedStock === 0) ? "bg-gray-400 cursor-not-allowed" : "cursor-pointer"}`}
                    style={{
                      backgroundColor:
                        selectedCrossProduct.size?.length > 0 &&
                          (!crossSelectedSize || crossSelectedStock === 0)
                          ? "#ccc"
                          : themeColor,
                    }}
                    onMouseEnter={(e) => {
                      if (
                        !(
                          selectedCrossProduct.size?.length > 0 &&
                          (!crossSelectedSize || crossSelectedStock === 0)
                        )
                      ) {
                        const darkenedColor = darkenHexColor(themeColor, 0.15);
                        e.currentTarget.style.backgroundColor = darkenedColor;
                      }
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor =
                        selectedCrossProduct.size?.length > 0 &&
                          (!crossSelectedSize || crossSelectedStock === 0)
                          ? "#ccc"
                          : themeColor;
                    }}
                    onClick={async (e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setCrossMessage(null);
                      const moq = parseInt(
                        selectedCrossProduct?.moq || "1",
                        10,
                      );
                      const qty = parseInt(crossQuantity, 10);
                      if (
                        selectedCrossProduct.size?.length !== 0 &&
                        (!crossSelectedSize || !crossSelectedSizePrice)
                      ) {
                        setCrossMessage("Please select a size");
                        clearCrossMessage();
                        return;
                      }
                      if (
                        selectedCrossProduct.size?.length !== 0 &&
                        crossSelectedStock === 0
                      ) {
                        setCrossMessage("Selected size is out of stock");
                        clearCrossMessage();
                        return;
                      }
                      if (qty < moq) {
                        setCrossMessage(`Minimum order quantity is ${moq}`);
                        clearCrossMessage();
                        return;
                      }
                      const payload = {
                        product_auto_id: selectedCrossProduct.productAutoId,
                        added_by_id: selectedCrossProduct.user_auto_id,
                        cart_quantity: qty,
                        ...(selectedCrossProduct.size?.length !== 0 && {
                          size: crossSelectedSizeId,
                          size_price: crossSelectedSizePrice,
                        }),
                      };
                      try {
                        const res = await addToCart(payload);

                        if (res?.status === "1") {
                          // ✅ Successfully added
                          setCartMessage({
                            text: res.message,
                            type: "success",
                          });

                          setTimeout(() => {
                            navigate("/cart");
                          }, 1000);

                        } else if (
                          res?.message &&
                          res.message.toLowerCase().includes("already")
                        ) {
                          // 🚫 Already in cart
                          setCartMessage({
                            text: "Product is already present in cart",
                            type: "error",
                          });

                        } else {
                          // ❌ Any other failure
                          setCartMessage({
                            text: res?.message || "Unable to add product to cart",
                            type: "error",
                          });
                        }

                      } catch (error) {
                        setCrossMessage(error.message);
                        clearCrossMessage();
                        console.log("Failed to add to cart -", error);
                      }
                    }}
                  >
                    {selectedCrossProduct.size?.length === 0
                      ? `Add to Cart | ₹ ${selectedCrossProduct.price}`
                      : !crossSelectedSize
                        ? "SELECT A SIZE"
                        : crossSelectedStock === 0
                          ? "Size Out of Stock"
                          : `Add to Cart | ₹ ${crossSelectedSizePrice}`}
                  </button>
                </div>
                <div className="mt-4 text-center">
                  <Link
                    to={`/product-detail/${selectedCrossProduct.productAutoId}`}
                    className="text-inherit"
                  >
                    <button className="text-black underline">
                      View Details
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {faqs.length > 0 && (
        <section className="faq-section">
          <h2 className="faq-title">Frequently Asked Questions</h2>

          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <h3 className="faq-question">{faq.question}</h3>
              <p className="faq-answer">{faq.answer}</p>
            </div>
          ))}
        </section>
      )}

      {faqs.length > 0 && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              mainEntity: faqs.map((faq) => ({
                "@type": "Question",
                name: faq.question,
                acceptedAnswer: {
                  "@type": "Answer",
                  text: faq.answer,
                },
              })),
            }),
          }}
        />
      )}
    </>
  );
};

export default ProductDetail2;
